'use client';
import React from 'react';

export type MetricItem = {
  label: string;
  value: string | number | null;
};

interface MetricsTableProps {
  title: string;
  metrics: MetricItem[];
}

export const MetricsTable: React.FC<MetricsTableProps> = ({ title, metrics }) => {
  return (
    <div className="flex flex-col">
      <h3 className="font-bold text-lg mb-3">{title}</h3>
      <div className="card grid grid-cols-2 bg-white overflow-hidden p-0">
        {metrics.map((metric, index) => {
          const isEmpty = metric.value === '-';

          return (
            <div
              className={`
                flex flex-col items-start gap-1 p-3 bg-white border-b border-[#e9ecef]
                [&:nth-child(odd)]:border-r [&:nth-child(odd)]:border-[#e9ecef]
                [&:last-child]:border-b-0 [&:nth-last-child(2):nth-child(odd)]:border-b-0

                md:grid md:grid-cols-[2fr_1.2fr] md:gap-3 md:px-4 md:py-2.5 md:transition-colors md:hover:bg-[#f5f5f5]
                md:[&:nth-child(4n+1)]:bg-[#fcfcfc] md:[&:nth-child(4n+2)]:bg-[#fcfcfc]
                md:[&:nth-last-child(-n+2)]:border-b-0
              `}
              key={index}
            >
              <div
                className={`
                text-[11px] text-[#828282] font-normal text-left flex items-start leading-[1.2] overflow-hidden text-ellipsis whitespace-normal h-8
                md:text-[13px] md:text-[#666666] md:items-center md:whitespace-nowrap md:h-auto
              `}
              >
                {metric.label}
              </div>
              <div
                className={`
                text-[14px] font-semibold text-[#1a1a1a] text-left flex items-center justify-start leading-[1.2]
                md:text-right md:justify-end md:whitespace-nowrap
                ${isEmpty ? 'text-[#999999] font-normal' : ''}
              `}
              >
                {metric.value ?? '-'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MetricsTable;
